import { Tables, TablesUpdate } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const updateOrganization = async (data: Omit<TablesUpdate<'organisation'>,'id'> & {id: Tables<'organisation'>['id']}) => await supabase.from('organisation').update(data).eq('id', data.id).throwOnError()